import {
  Directive,
  OnInit,
  ElementRef,
  HostListener,
  Renderer2,
  AfterContentChecked,
} from "@angular/core";
import { DecimalPipe } from "@angular/common";

@Directive({
  selector: "[appCurrencyMask]",
})
export class CurrencyMaskDirective implements OnInit, AfterContentChecked {
  currencyChars = new RegExp("[,]", "g"); // we're going to remove commas and dots

  tempValue = null;
  didRun = false;

  constructor(
    public el: ElementRef,
    public renderer: Renderer2,
    private decimalPipe: DecimalPipe
  ) {}

  ngOnInit() {
    this.format(this.el.nativeElement.value); // format any initial values
  }

  ngAfterContentChecked() {
    if (
      this.tempValue !== this.el.nativeElement.value &&
      !this.didRun &&
      this.el.nativeElement.value !== undefined &&
      this.el.nativeElement.value !== null &&
      this.el.nativeElement.value !== ""
    ) {
      this.tempValue = this.el.nativeElement.value;
      this.format(this.el.nativeElement.value); // format any initial values
      this.didRun = true;
    }
  }

  @HostListener("focus", ["$event.target.value"]) onFocus(e: string) {
    if (!e) return;
    const raw = parseFloat(String(e).replace(this.currencyChars, ""));
    this.renderer.setProperty(this.el.nativeElement, "value", raw);
  }

  @HostListener("blur", ["$event.target.value"]) onBlur(val: string) {
    this.format(val);
  }

  @HostListener("paste", ["$event"]) onPaste(event: ClipboardEvent) {
    event.preventDefault();
    this.format(event.clipboardData.getData("text/plain"));
  }

  format(val: string) {
    // 1. test for non-number characters and replace/remove them
    const numberFormat = parseFloat(
      String(val).replace(this.currencyChars, "")
    );

    // 2. format the number (add commas)
    const usd = this.decimalPipe.transform(numberFormat, "1.0", "en-US");

    // 3. replace the input value with formatted numbers
    this.renderer.setProperty(this.el.nativeElement, "value", usd);
  }
}
